import { buildVerboseLogger } from './verbose-logger';
import { buildProdClientLogger } from './prod-logger';
let logger;
const env = process.env.NODE_ENV || process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV;
// When vercel_env is 'development', then it's local.  'preview' and 'production' means we're running on the Vercel platform.
const onVercel = (process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV || 'development').toLowerCase() !== 'development';
const isProduction = (process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV || '').toLowerCase() === 'production';
const isServer = typeof process !== 'undefined' && process.versions != null && process.versions.node != null;
// verbose logs on server or non-production envs
const useVerboseLogger = isServer || !isProduction;
const info = {
    env,
    node_env: process.env.NODE_ENV,
    node_version: (typeof process !== 'undefined' && process.versions && process.versions.node) ? process.versions.node : 'n/a',
    vercel_env: process.env.NEXT_PUBLIC_VERCEL_ENV || process.env.VERCEL_ENV,
    supa: process.env.SUPABASE_URL || 'no supabase url',
    isServer,
    useVerboseLogger,
    onVercel,
};
if (useVerboseLogger) {
    // loggingOnVercel will change some of the output format.
    logger = buildVerboseLogger(onVercel);
    // Production server logs keep info and above: debug lines carry request and user details that don't belong in
    // retained logs (they used to include users' session tokens)
    if (isServer && isProduction)
        logger.setLevel(logger.levels.INFO);
    logger.debug('VERBOSE LOGGING', info);
}
else {
    // We're on production client, so should only log info and above with no extra formatting
    logger = buildProdClientLogger();
    logger.info('PROD CLIENT LOGGING');
}
export default logger;
